import * as React from "react";
import styled from "styled-components";
import { focusRing } from "@sproutsocial/seeds-react-mixins";
import { RAIL_BUTTON_HEIGHT, RAIL_BUTTON_SIZE } from "./ActionRail";

const StyledButton = styled.button`
  width: ${RAIL_BUTTON_SIZE}px;
  height: ${RAIL_BUTTON_HEIGHT}px;
  display: inline-grid;
  place-items: center;
  border-radius: ${(props) => props.theme.radii.outer};
  border: none;
  background: ${(props) => props.theme.colors.button.overlay.background.base};
  color: ${(props) => props.theme.colors.button.overlay.text.base};
  cursor: pointer;
  outline: none;
  transition: all ${(props) => props.theme.duration.fast}
    ${(props) => props.theme.easing.ease_inout};

  &:hover {
    background: ${(props) =>
      props.theme.colors.button.overlay.background.hover};
  }

  &:hover,
  &:active {
    transform: none;
  }

  &:focus-visible {
    ${focusRing}
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export type TypeActionRailButtonProps =
  React.ButtonHTMLAttributes<HTMLButtonElement>;

export const ActionRailButton = React.forwardRef<
  HTMLButtonElement,
  TypeActionRailButtonProps
>(({ children, ...rest }, ref) => (
  <StyledButton
    ref={ref}
    type="button"
    data-slot="action-rail-button"
    {...rest}
  >
    {children}
  </StyledButton>
));

ActionRailButton.displayName = "ActionRailButton";
